import { Injectable } from '@angular/core';
import { GroupMember, GroupsService } from '@era/security-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { MemberUserResolverActions, GroupApiActions, MemberUserListActions } from './member-user.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class MemberUserEffects {
  constructor(
    private readonly groupService: GroupsService,
    private readonly actions$: Actions
  ) {}

  groupMemberLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberUserResolverActions.memberUsersRequested),
      mergeMap(({ group }) =>
        safeMap(
          this.groupService.getGroupUsers(group.id),
          (members: GroupMember[]) => GroupApiActions.memberUsersLoaded({ memberUsers: members }),
          (error) => GroupApiActions.memberUsersLoadedError({ error })
        )
      )
    );
  });

  groupMemberDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupApiActions.memberUsersGroupDeleted),
      mergeMap(({ memberUser }) =>
        safeMap(
          this.groupService.removeUserFromGroup(memberUser.parentId, memberUser.id),
          () => MemberUserListActions.memberUsersDeleted({ memberUser }),
          (error) => GroupApiActions.memberUsersDeleteError({ error })
        )
      )
    );
  });

  groupMemberAddedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupApiActions.memberUsersAdded),
      mergeMap(({ group, userToAdd }) =>
        safeMap(
          this.groupService.addUserToGroup(group.id, { id: userToAdd.id }),
          () => MemberUserListActions.memberUsersAdded({ group, userToAdd }),
          (error) => GroupApiActions.memberUsersAddedError({ error })
        )
      )
    );
  });
}
